import { compose } from 'redux';
import { connect } from 'react-redux';
import * as errorDiagnosticsSharing from '@store/errorDiagnostics/sharing/actions';
import { sharingIsFetchingSelector } from '@store/errorDiagnostics/sharing/selectors';
import ErrorDiagnostics from './ErrorDiagnostics';
import sharing from '../common/sharing';

const ErrorDiagnosticsSharing = compose(
  connect(sharingIsFetchingSelector, {
    init: errorDiagnosticsSharing.initRequest,
    getSharing: errorDiagnosticsSharing.getSharing,
  }),
  sharing(),
)(ErrorDiagnostics);

export default ErrorDiagnosticsSharing;
